import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { languages } from 'i18n';
import { functions } from 'fb';
import { useUserState } from 'hooks/User';

// Material UI
import Button, { ButtonProps } from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const LangSelect = ({ className, sx: sxProp }: ButtonProps) => {
  const { t, i18n } = useTranslation(['common']);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const user = useUserState();

  const setLang = async (code: string) => {
    i18n.changeLanguage(code);
    setAnchorEl(null);

    if (user) {
      functions.httpsCallable('users-ChangeLanguage')({
        language: code,
      });
    }
    // Change html lng when language is changed
    document.documentElement.setAttribute('lang', code);
  };
  return (
    <>
      <Button
        aria-controls='language-menu'
        aria-haspopup='true'
        className={className}
        color='secondary'
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={[
          {
            width: 'fit-content',
            minWidth: 150,
            margin: 'auto',
            mt: 1,
          },
          ...(Array.isArray(sxProp) ? sxProp : sxProp ? [sxProp] : []),
        ]}
        variant='outlined'>
        {t('LANGUAGE')}
      </Button>
      <Menu anchorEl={anchorEl} id='language-menu' onClose={() => setAnchorEl(null)} open={Boolean(anchorEl)}>
        {languages.map((lang, i) => (
          <MenuItem key={i} onClick={() => setLang(lang.code)} sx={{ minWidth: 150 }}>
            {lang.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LangSelect;
